export default __webpack_public_path__ + "static/media/ren.c2dfd6d3.png";